import { matchPath } from 'react-router';

import { UNAUTHORIZED_ROUTES } from 'routes/config/constants';

const LAST_LOGIN_PATH_KEY = 'lastLoginPath';
const LAST_LOGIN_USER_ID_KEY = 'lastLoginUserId';

const isUnauthorizedPath = (path: string) => {
  const [pathname] = path.split('?');
  return UNAUTHORIZED_ROUTES.some((route) => !!matchPath(route, pathname));
};

export class ReloginRedirect {
  static deleteSessionPath() {
    sessionStorage.removeItem(LAST_LOGIN_PATH_KEY);
  }

  static deleteSessionUserId() {
    sessionStorage.removeItem(LAST_LOGIN_USER_ID_KEY);
  }

  static getLastSessionData() {
    const lastLoginPath = sessionStorage.getItem(LAST_LOGIN_PATH_KEY);
    const lastLoginUserId = sessionStorage.getItem(LAST_LOGIN_USER_ID_KEY);

    // Tabs opened before the setSessionPath guard existed may still hold an auth-page URL
    if (lastLoginPath && isUnauthorizedPath(lastLoginPath)) {
      ReloginRedirect.deleteSessionPath();
      return { lastLoginPath: null, lastLoginUserId };
    }

    return { lastLoginPath, lastLoginUserId };
  }

  static setSessionPath(pathname: string) {
    if (isUnauthorizedPath(pathname)) {
      return;
    }

    sessionStorage.setItem(LAST_LOGIN_PATH_KEY, pathname);
  }

  static setSessionUserId(userId: string) {
    sessionStorage.setItem(LAST_LOGIN_USER_ID_KEY, userId);
  }
}
